/**
 * External dependencies
 */
import AOS from 'aos';

/**
 * Internal dependencies
 */
import './header';
import './toggler';
import './img-loader';
import './scroll-top';

// Pages
import './home';

window.onload = function() {
	AOS.init();
}
